import React from 'react'
import { Link } from 'react-router-dom'
import './NotFoundPage.scss'
import { SEO } from '../../components/SEO'

export const NotFoundPage: React.FC = () => {
  return (
    <div className="notFoundPage">
      <SEO
        title="Sivua ei löytynyt | Aamukasaaja"
        description="Sivua ei löytynyt. Palaa etusivulle jatkaaksesi Aamukasaajan käyttöä."
        keywords="aamukasa, tj, laskuri, intti, asepalvelus"
        robots="noindex, nofollow"
        canonical="https://aamukasaaja.fi/404"
      />
      <h1>404</h1>
      <p>
        Täällä ei ole mitään nähtävää. Olet yhtä hukassa kuin alokas ensimmäisellä metsäleirillä
        ilman karttaa ja kompassia.
      </p>
      <Link to="/" className="homeLink">
        Palaa etusivulle
      </Link>
    </div>
  )
}
